import React, { useEffect, useState } from "react";
import { InputField, SubmitButton, TextComponent } from "../../../../components";
import styles from "./EditChatRoom.module.css";
import { Col, Row, List } from "antd";
import { BsCheckCircleFill, BsCircle } from "react-icons/bs";
import RoomImage from "../../../../assets/RoomImage.png";
import { AiFillPlusCircle } from "react-icons/ai";
import { useLocation, useNavigate } from "react-router-dom";
import { EventMiddleware } from "../../../../Store/Middlewares/EventMiddleware";
import { ChatMiddleware } from "../../../../Store/Middlewares/ChatMiddleware";
import { useDispatch } from "react-redux";
import { showAlert } from "../../../../Store/Actions/GeneralActions";
import { roles } from "../../../../config/roles";
import Storage from "../../../../utills/AsyncStorage";

const EditChatRoom = () => {
  const dispatch = useDispatch();
  const location = useLocation();
  const role = Storage.getERole("@role");

  const editData = location?.state?.data
  const [chatRoomName, setchatRoomName] = useState(editData?.name);
  const [topic, setTopic] = useState("");
  const [memberList, setMemberList] = useState([]);
  const [selectedMemberList, setSelectedMemberList] = useState([]);
  const [hashtags, setHashtags] = useState(editData?.topics);
  const [selectedHashtags, setSelectedHashtags] = useState([]);
  const [selectedEvent, setselectedEvent] = useState(null)
  const [eventImage, setEventImage] = useState(editData?.image)
  const [selectedEventImage, setSelectedEventImage] = useState(null)
  const hiddenFileInput = React.useRef();
  const handleClick = (event) => {
    hiddenFileInput.current.click();
  };
  const navigate = useNavigate()

  const onPressAddMember = (item) => {
    let find = selectedMemberList?.find(i => i?.id == item?.id)
    if (!find) {
      setSelectedMemberList([...selectedMemberList, item]);
    } else {
      selectedMemberList.splice(selectedMemberList.indexOf(find), 1);
      setSelectedMemberList([...selectedMemberList])
    }

  };

  const onPressAddTopics = (e) => {
    e.preventDefault();
    if (!topic) {
      alert('Please enter topic')
    } else {
      let selected = [...selectedHashtags]
      let data = [...hashtags]
      if (topic.includes('#')) {
        data.push({ id: null, name: topic })
        selected.push({ id: null, name: topic })
      } else {
        data.push({ id: null, name: "#" + topic })
        selected.push({ id: null, name: "#" + topic })
      }
      setHashtags(data)
      setSelectedHashtags(selected)
      setTopic('')
    }
  }

  useEffect(() => {
    if (role == roles.vendor) {
      dispatch(
        EventMiddleware.getAllVendor({
          role: 'vendor',
          search: '',
          loading: false,
        }),
      )
        .then(data => {
          setMemberList(data);
        })
        .catch();
      getCurrentEventGuests();
    } else {
      getAllGuests();
      getCurrentEventGuests();
    }
    // getAllGuests()
    // getCurrentEventGuests()
  }, [])

  const getAllGuests = () => {
    dispatch(EventMiddleware.getEventGuest({ event_id: editData?.event_id, search: '' }))
      .then((res) => { setMemberList(res) }).catch()
  }

  const getCurrentEventGuests = () => {
    dispatch(ChatMiddleware.getChatRoomMembers({ id: editData?.id, name: '' }))
      .then((Data) => { setSelectedMemberList(Data) })
      .catch()
  }

  const onPressSaveChanges = () => {
    if (chatRoomName == " ") {
      dispatch(showAlert({ message: 'Please enter chat name.!' }))
    }
    else if (selectedMemberList.length == 0) {
      dispatch(showAlert({ message: 'Please select member.!' }))
    }
    else {
      let data = {
        id: editData?.id,
        name: chatRoomName,
        topics: selectedHashtags ? selectedHashtags : [],
        image: selectedEventImage ? selectedEventImage : null,
        members: selectedMemberList,
      }
      console.log('data', data)
      dispatch(ChatMiddleware.editChatRoom(data)).then(() => { navigate(-1) }).catch()
    }
  }

  return (
    <div className={styles.mainCon}>
      <TextComponent text={"Chat Room Name"} textClass={styles.subHeading} />
      <div className={styles.inputStyle}>
        <InputField
          placeholder={"Name"}
          value={chatRoomName}
          onChange={(e) => setchatRoomName(e.target.value)}
        />
      </div>

      <Row className={styles.addMemberView}>
        <Col className={styles.colMember}>
          <div className={styles.topicDiv}>
            <TextComponent
              text={"Discuss about the Topic"}
              textClass={styles.subHeading}
            />
            <div className={styles.topicInputDiv}>
              <div className={styles.topicInput}>
                <input
                  placeholder={"#singing"}
                  value={topic}
                  onChange={(e) => setTopic(e.target.value)}
                ></input>
              </div>
              <div className={styles.plusIconDiv}>
                <AiFillPlusCircle onClick={onPressAddTopics} size={40} />
              </div>
            </div>
            <List
              dataSource={hashtags}
              className={styles.hashtagsList}
              grid={{}}
              itemLayout="horizontal"
              renderItem={(item, index) => (
                <Row key={index} className={styles.hashtagsItem}>
                  {/* <TextComponent text={"#"} /> */}
                  <TextComponent text={item?.name} />
                </Row>
              )}
            />
          </div>

          <TextComponent text={"Add member"} textClass={styles.subHeading} />
          {/* <div className={styles.listDiv}> */}
          <List
            dataSource={memberList}
            className={styles.list}
            renderItem={(item, index) => {
              // let selected = selectedMemberList.includes(item)
              let isAlreadyExist = selectedMemberList?.find(i => i.id == item?.id)
              return (
                <Row
                  onClick={() => onPressAddMember(item, index)}
                  key={index}
                  className={styles.itemStyle}
                >
                  {isAlreadyExist ? (
                    <BsCheckCircleFill className={styles.iconStyle} />
                  ) : (
                    <BsCircle className={styles.iconStyle} />
                  )}
                  <TextComponent
                    text={item?.name}
                    textClass={
                      isAlreadyExist ? styles.itemTextTrue : styles.itemTextFalse
                    }
                  />
                </Row>
              )
            }}
          />
          {/* </div> */}
          <div className={styles.btn}>
            <SubmitButton
              title={"Save"}
              btnClass={styles.btnStyle}
              onClick={() => onPressSaveChanges()}
            />
          </div>
        </Col>

        <Col className={styles.colImage}>
          <div onClick={handleClick}>
            {/* <img src={RoomImage} /> */}
            <img src={selectedEventImage ? URL.createObjectURL(selectedEventImage) : eventImage ? eventImage : RoomImage} />
          </div>
          <input
            type="file"
            accept="image/*"
            onChange={(e) => setSelectedEventImage(e.target.files[0])}
            ref={hiddenFileInput}
            style={{ display: "none" }}
          />
        </Col>
      </Row>
    </div>
  );
};

export default EditChatRoom;
